import { Notification, NotificationType } from '@dreryk/react-components';
import { createSingleInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type QuotaIndicatorProps = {
   remainingMinutes: number;
   notConfigured: boolean;
   nearLimit: boolean;
   isQuotaExhausted: boolean;
};

export const QuotaIndicator = (props: QuotaIndicatorProps): JSX.Element | null => {
   if (props.isQuotaExhausted) {
      return (
         <Notification
            testId={'quotaExhausted'}
            type={NotificationType.ERROR}
            label={translationKeys.quota.exhausted}
         />
      );
   }
   const remainingLabel = createSingleInterpolatedTranslationKey(
      translationKeys.quota.remaining,
      'minutes',
      props.notConfigured ? '---' : props.remainingMinutes
   );

   if (props.nearLimit && !props.notConfigured) {
      return (
         <Notification testId={'quotaNearLimit'} type={NotificationType.WARNING} label={remainingLabel}>
            <Translate>{translationKeys.quota.nearLimit}</Translate>
         </Notification>
      );
   }

   return <Notification testId={'quotaRemaining'} type={NotificationType.INFO} label={remainingLabel} />;
};
